import { isLabeledStatement } from "typescript";
import Label from "../Label";

type Props = {
  lengths: string[];
  table: string[][];
  vertical: string;
  horizontal: string;
  unit?: string;
};

const Table: React.FC<Props> = ({
  lengths,
  table,
  horizontal,
  vertical,
  unit,
}) => {
  return (
    <section className="table_container">
      <p className="table_hilo">{vertical}</p>
      <p className="table_largo">{horizontal + " " + (unit && unit)}</p>
      <table className="table">
        <thead>
          <tr>
            <th></th>
            {lengths &&
              lengths.map((vari, i) => {
                return <th key={`${vari}_${i}`}>{vari}</th>;
              })}
          </tr>
        </thead>
        <tbody>
          {table &&
            table.map((row) => {
              return (
                <tr key={row[0]}>
                  {row.map((value, i) => {
                    if (i == 0) {
                      return (
                        <td className="gauges" key={`${value}_${i}`}>
                          {value}
                        </td>
                      );
                    } else {
                      return <td key={`${value}_${i}`}>{value}</td>;
                    }
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </section>
  );
};

export default Table;
